import React from 'react'
import { useIntl } from 'react-intl'

export const MailTo = () => {
    const intl = useIntl()
    return <>{ intl.locale === 'cs-CZ' 
        ? <a href='mailto: albert@levicek.cz' title='Albert Levíček'>albert@levicek.cz</a>
        : <a href='mailto: albert@levicek.cz' title='Albert Levíček'>albert@levicek.cz</a>
    }</>
}